exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{background-color:#fff;padding:24px}.link{color:var(--accent-color);font-size:.9em;display:inline-block;margin-bottom:5px;text-decoration:none}.link:hover{text-decoration:underline}.loading{color:#848484;font-size:.9em;display:inline-block;margin-bottom:5px}", ""]);

// exports
